// document.addEventListener('DOMContentLoaded', function() {
//   const addToCartForms = document.querySelectorAll('form[id^="AddToCartForm-"]');
  
//   addToCartForms.forEach(form => {
//     form.addEventListener('submit', function(event) {
//       event.preventDefault();
      
//       const formData = new FormData(form);
//       const variantId = form.querySelector('.variant-id-input').value;
//       const quantity = form.querySelector('.quantity__input') ? parseInt(form.querySelector('.quantity__input').value) : 1;
      
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({
//           id: variantId,
//           quantity: quantity
//         })
//       })
//       .then(response => {
//         if (!response.ok) {
//           throw new Error('Failed to add item to cart');
//         }
//         return response.json();
//       })
//       .then(data => {
//         // Immediately update cart UI with the added quantity
//         updateCartUI(quantity);
        
//         // Trigger cart drawer to open
//         openCartDrawer();
//       })
//       .catch(error => {
//         console.error('Error adding to cart:', error);
//         alert('There was an error adding the item to your cart. Please try again.');
//       });
//     });
//   });
  
//   // Function to open cart drawer
//   function openCartDrawer() {
//     const cartDrawer = document.querySelector('.cart-drawer'); // Adjust selector to match your cart drawer
//     if (cartDrawer) {
//       cartDrawer.classList.add('active'); // Add class to show drawer
//       // Fetch and update cart drawer content
//       fetchCartContent();
//     }
//   }
  
//   // Function to fetch and update cart content
//   function fetchCartContent() {
//     fetch('/cart.js')
//       .then(response => response.json())
//       .then(cart => {
//         // Update cart drawer UI with cart data
//         const cartCount = document.querySelector('.cart-count');
//         if (cartCount) {
//           cartCount.textContent = cart.item_count;
//         }
//         // Add logic to update cart drawer content (e.g., list items)
//         updateCartDrawerItems(cart.items);
//       })
//       .catch(error => console.error('Error fetching cart:', error));
//   }
  
//   // Function to update cart UI (e.g., cart count in header)
//   // function updateCartUI(addedQuantity) {
//   //   fetch('/cart.js')
//   //     .then(response => response.json())
//   //     .then(cart => {
//   //       // const cartCount = document.querySelector('.cart-count');
//   //       const cartCount = document.querySelector('.ajax-cart-count');
//   //       if (cartCount) {
//   //         cartCount.textContent = cart.item_count;
//   //       }

//   //       // Cart-Update Code - Ahiya Code karvano Se

       
//   //     })
//   //     .catch(error => {
//   //       console.error('Error updating cart UI:', error);
//   //       // Fallback: Increment cart count manually if fetch fails
//   //       const cartCount = document.querySelector('.ajax-cart-count');
//   //       if (cartCount && addedQuantity) {
//   //         const currentCount = parseInt(cartCount.textContent) || 0;
//   //         cartCount.textContent = currentCount + addedQuantity;
//   //       }
//   //     });
//   // }
  

//   // new code : for the update cart 
// function updateCartUI(addedQuantity) {
  
//   // Fetch cart data
//   fetch('/cart.js')
//     .then(response => {
//       return response.json();
//     })
//     .then(cart => {
      
//       // Update cart count
//       const cartCount = document.querySelector('.ajax-cart-count');
//       if (cartCount) {
//         cartCount.textContent = cart.item_count;
//       }
      
//       // Now fetch the cart drawer section to update the HTML
//       return fetch('/?sections=ajax-cart,ajax-cart-icon')
//         .then(response => response.json())
//         .then(sections => {
//           return { cart, sections };
//         });
//     })
//     .then(({ cart, sections }) => {
//       // Get the ajax cart element
//       const ajaxCart = document.getElementById('ajaxcart') || document.querySelector('.ajax-cart');
      
//       // Try to use renderContents if it exists
//       if (ajaxCart && typeof ajaxCart.renderContents === 'function') {
//         ajaxCart.renderContents({ ...cart, sections });
//       } else {
        
//         // Manual update - remove is-empty class from cart-pro
//         // const cartPro = document.querySelector('cart-pro.product-cart-items');
//         const cartPro = document.querySelector('ajax-cart');
        
//         if (cartPro && cartPro.classList.contains('is-empty')) {
//           cartPro.classList.remove('is-empty');
//         }
        
//         // Update the cart sections if available
//         if (sections) {
          
//           // Update cart icon section FIRST (before ajax-cart to avoid errors)
//           if (sections['ajax-cart-icon']) {
//             const ajaxCartIconContainer = document.getElementById('ajax-cart-icon');
//             if (ajaxCartIconContainer) {
//               const tempDiv = document.createElement('div');
//               tempDiv.innerHTML = sections['ajax-cart-icon'];
//               const newContent = tempDiv.querySelector('#ajax-cart-icon');
//               if (newContent) {
//                 // Use innerHTML instead of outerHTML to preserve the container
//                 ajaxCartIconContainer.innerHTML = newContent.innerHTML;
//               }
//             }
//           } else {
//           }
          
//           // Update main cart content (#ajaxcart section)
//           if (sections['ajax-cart']) {
//             const ajaxCartElement = document.querySelector('#ajaxcart');
//             if (ajaxCartElement) {
//               const tempDiv = document.createElement('div');
//               tempDiv.innerHTML = sections['ajax-cart'];
//               const newAjaxCart = tempDiv.querySelector('#ajaxcart');
//               if (newAjaxCart) {
//                 // Use innerHTML to update content without recreating the element
//                 ajaxCartElement.innerHTML = newAjaxCart.innerHTML;
//               }
//             }
//           } else {
//           }
          
//           // Open the cart drawer after updating
//           setTimeout(() => {
//             const updatedAjaxCart = document.getElementById('ajaxcart') || document.querySelector('.ajax-cart');
            
//             if (updatedAjaxCart) {
//               if (typeof updatedAjaxCart.open === 'function') {
//                 updatedAjaxCart.open();
//               } else {
//                 // Fallback: Add active class
//                 const drawerInner = updatedAjaxCart.querySelector('.drawer-inner');
//                 if (drawerInner) {
//                   drawerInner.classList.add('active');
//                   updatedAjaxCart.classList.add('active');
//                   document.body.classList.add('overflow-hidden');
//                 }
//               }
              
//               // Re-attach event listeners for the drawer
//               const overlay = updatedAjaxCart.querySelector('#ajaxcart-overlay');
//               if (overlay) {
//                 overlay.addEventListener('click', function() {
//                   if (updatedAjaxCart.close && typeof updatedAjaxCart.close === 'function') {
//                     updatedAjaxCart.close();
//                   } else {
//                     drawerInner.classList.remove('active');
//                     updatedAjaxCart.classList.remove('active');
//                     document.body.classList.remove('overflow-hidden');
//                   }
//                 });
//               }
              
//               const closeBtn = updatedAjaxCart.querySelector('.close-ajax-cart');
//               if (closeBtn) {
//                 closeBtn.addEventListener('click', function() {
//                   if (updatedAjaxCart.close && typeof updatedAjaxCart.close === 'function') {
//                     updatedAjaxCart.close();
//                   } else {
//                     const drawerInner = updatedAjaxCart.querySelector('.drawer-inner');
//                     if (drawerInner) {
//                       drawerInner.classList.remove('active');
//                     }
//                     updatedAjaxCart.classList.remove('active');
//                     document.body.classList.remove('overflow-hidden');
//                   }
//                 });
//               }
//             }
//           }, 100);
//         } else {
//         }
//       }
//     })
//     .catch(error => {
//       console.error('=== ERROR updating cart UI ===');
//       console.error('Error details:', error);
//       console.error('Error stack:', error.stack);
      
//       // Fallback: Increment cart count manually if fetch fails
//       const cartCount = document.querySelector('.ajax-cart-count');
//       if (cartCount && addedQuantity) {
//         const currentCount = parseInt(cartCount.textContent) || 0;
//         cartCount.textContent = currentCount + addedQuantity;
//       }
//     });
// }
// //  new code END: 
//   // Function to update cart drawer items (customize based on your theme)
//   function updateCartDrawerItems(items) {
//     const cartDrawerContent = document.querySelector('.cart-drawer-content'); // Adjust selector
//     if (cartDrawerContent) {
//       // Example: Render cart items
//       cartDrawerContent.innerHTML = items.map(item => `
//         <div class="cart-item">
//           <span>${item.title}</span>
//           <span>Quantity: ${item.quantity}</span>
//         </div>
//       `).join('');
//     }
//   }
// });
document.addEventListener('DOMContentLoaded', function() {
  const addToCartForms = document.querySelectorAll('form[id^="AddToCartForm-"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      
      const formData = new FormData(form);
      // console.log("formData:",formData);
      // console.log("formData:",form);
      const variantId = form.querySelector('.variant-id-input').value;
      // console.log("variantId:",variantId);
      const quantity = form.querySelector('.quantity__input') ? parseInt(form.querySelector('.quantity__input').value) : 1;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add item to cart');
        }
        // console.log("response1");
        // console.log(response);
        return response.json();
      })
      .then(data => {
        // Immediately update cart UI with the added quantity
        // console.log("response2:", data); 
        updateCartUI(quantity);
        
        // Trigger cart drawer to open
        openCartDrawer();
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('There was an error adding the item to your cart. Please try again.');
      });
    });
  });
  
  // Function to open cart drawer
  function openCartDrawer() {
    const cartDrawer = document.querySelector('.cart-drawer'); // Adjust selector to match your cart drawer
    if (cartDrawer) {
      cartDrawer.classList.add('active'); // Add class to show drawer
      // Fetch and update cart drawer content
      fetchCartContent();
    }
  }
  
  // Function to fetch and update cart content
  function fetchCartContent() {
  // console.log("inside 1")
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart drawer UI with cart data
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
        // Add logic to update cart drawer content (e.g., list items)
        updateCartDrawerItems(cart.items);
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // new code : for the update cart 
function updateCartUI(addedQuantity) {
  // console.log("=== UPDATE CART UI START ===");
  // console.log("Added Quantity:", addedQuantity);
  
  // Fetch cart data
  fetch('/cart.js')
    .then(response => {
      // console.log("Fetch response status:", response.status);
      return response.json();
    })
    .then(cart => {
      // console.log("Cart data received:", cart);
      // console.log("Cart item count:", cart.item_count);
      
      // Update cart count
      const cartCount = document.querySelector('.ajax-cart-count');
      // console.log("Cart count element found:", !!cartCount);
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        // console.log("Cart count updated to:", cart.item_count);
      }
      
      // Now fetch the cart drawer section to update the HTML
      // console.log("Fetching cart drawer section...");
      return fetch('/?sections=ajax-cart,ajax-cart-icon')
        .then(response => response.json())
        .then(sections => {
          // console.log("Sections received:", sections);
          return { cart, sections };
        });
    })
    .then(({ cart, sections }) => {
      // Get the ajax cart element
      const ajaxCart = document.getElementById('ajaxcart') || document.querySelector('.ajax-cart');
      // console.log("Ajax cart element found:", !!ajaxCart);
      // console.log("renderContents function exists:", ajaxCart && typeof ajaxCart.renderContents === 'function');
      
      // Try to use renderContents if it exists
      if (ajaxCart && typeof ajaxCart.renderContents === 'function') {
        // console.log("Calling renderContents method...");
        ajaxCart.renderContents({ ...cart, sections });
      } else {
        // console.log("Manual update mode - no renderContents found");
        
        // Manual update - remove is-empty class from cart-pro
        // const cartPro = document.querySelector('cart-pro.product-cart-items');
        const cartPro = document.querySelector('ajax-cart');
        // console.log("Cart-pro element found:", !!cartPro);
        // console.log("Has is-empty class:", cartPro && cartPro.classList.contains('is-empty'));
        
        if (cartPro && cartPro.classList.contains('is-empty')) {
          cartPro.classList.remove('is-empty');
          // console.log("Removed is-empty class from cart-pro");
        }
        
        // Update the cart sections if available
        if (sections) {
          // console.log("Updating sections...");
          
          // Update cart icon section FIRST (before ajax-cart to avoid errors)
          if (sections['ajax-cart-icon']) {
            // console.log("ajax-cart-icon section exists in response");
            const ajaxCartIconContainer = document.getElementById('ajax-cart-icon');
            // console.log("ajax-cart-icon container found:", !!ajaxCartIconContainer);
            if (ajaxCartIconContainer) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = sections['ajax-cart-icon'];
              const newContent = tempDiv.querySelector('#ajax-cart-icon');
              if (newContent) {
                // Use innerHTML instead of outerHTML to preserve the container
                ajaxCartIconContainer.innerHTML = newContent.innerHTML;
                // console.log("Updated ajax-cart-icon section");
              }
            }
          } 
          
          if (sections['ajax-cart']) {
            const ajaxCartElement = document.querySelector('#ajaxcart');
            if (ajaxCartElement) {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = sections['ajax-cart'];
              const newAjaxCart = tempDiv.querySelector('#ajaxcart');
              if (newAjaxCart) {
                ajaxCartElement.innerHTML = newAjaxCart.innerHTML;
              }
            }
          } else {
            console.log("ajax-cart section NOT in response");
          }
          
          // Open the cart drawer after updating
          // setTimeout(() => {
          //   const updatedAjaxCart = document.getElementById('ajaxcart') || document.querySelector('.ajax-cart');
          //   if (updatedAjaxCart) {
          //     if (typeof updatedAjaxCart.open === 'function') {
          //       updatedAjaxCart.open();
          //       // console.log("✓ Drawer opened using open() method");
          //     } else {
          //       // Fallback: Add active class
          //       const drawerInner = updatedAjaxCart.querySelector('.drawer-inner');
          //       if (drawerInner) {
          //         drawerInner.classList.add('active');
          //         updatedAjaxCart.classList.add('active');
          //         document.body.classList.add('overflow-hidden');
          //       }
          //     }
              
          //     // Re-attach event listeners for the drawer
          //     const overlay = updatedAjaxCart.querySelector('#ajaxcart-overlay');
          //     if (overlay) {
          //       overlay.addEventListener('click', function() {
          //         if (updatedAjaxCart.close && typeof updatedAjaxCart.close === 'function') {
          //           updatedAjaxCart.close();
          //         } else {
          //           drawerInner.classList.remove('active');
          //           updatedAjaxCart.classList.remove('active');
          //           document.body.classList.remove('overflow-hidden');
          //         }
          //       });
          //       // console.log("✓ Overlay click listener attached");
          //     }
              
          //     const closeBtn = updatedAjaxCart.querySelector('.close-ajax-cart');
          //     if (closeBtn) {
          //       closeBtn.addEventListener('click', function() {
          //         if (updatedAjaxCart.close && typeof updatedAjaxCart.close === 'function') {
          //           updatedAjaxCart.close();
          //         } else {
          //           const drawerInner = updatedAjaxCart.querySelector('.drawer-inner');
          //           if (drawerInner) {
          //             drawerInner.classList.remove('active');
          //             document.body.classList.remove('overflow-hidden');
          //           }
          //           updatedAjaxCart.classList.remove('active');
          //         }
          //       });
          //       // console.log("✓ Close button listener attached");
          //     }
          //   }
          // }, 100);
          setTimeout(() => {
            const updatedAjaxCart = document.getElementById('ajaxcart') || document.querySelector('.ajax-cart');
            if (!updatedAjaxCart) return;

            const drawerInner = updatedAjaxCart.querySelector('.drawer-inner');

            // ✅ OPEN DRAWER
            if (typeof updatedAjaxCart.open === 'function') {
              updatedAjaxCart.open();
            } else {
              if (drawerInner) drawerInner.classList.add('active');
              updatedAjaxCart.classList.add('active');
              document.body.classList.add('overflow-hidden');
            }
          
            const closeDrawer = () => {
              if (typeof updatedAjaxCart.close === 'function') {
                updatedAjaxCart.close();
              } else {
                if (drawerInner) drawerInner.classList.remove('active');
                updatedAjaxCart.classList.remove('active');
                document.body.classList.remove('overflow-hidden');
              }
            
              setTimeout(() => {
                document.body.classList.remove('overflow-hidden');
              }, 200);
            };
          
            const overlay = updatedAjaxCart.querySelector('#ajaxcart-overlay');
            if (overlay) {
              overlay.addEventListener('click', closeDrawer);
            }
          
            const closeBtn = updatedAjaxCart.querySelector('.close-ajax-cart');
            if (closeBtn) {
              closeBtn.addEventListener('click', closeDrawer);
            }
          }, 100);
        }
      }
    })
    .catch(error => {
      console.error('=== ERROR updating cart UI ===');
      console.error('Error details:', error);
      console.error('Error stack:', error.stack);
      
      const cartCount = document.querySelector('.ajax-cart-count');
      if (cartCount && addedQuantity) {
        const currentCount = parseInt(cartCount.textContent) || 0;
        cartCount.textContent = currentCount + addedQuantity;
      }
    });
}
  function updateCartDrawerItems(items) {
    const cartDrawerContent = document.querySelector('.cart-drawer-content'); 
    if (cartDrawerContent) {
      cartDrawerContent.innerHTML = items.map(item => `
        <div class="cart-item">
          <span>${item.title}</span>
          <span>Quantity: ${item.quantity}</span>
        </div>
      `).join('');
    }
  }
});